import React, { useContext } from "react";
import SOCompletedContent from "./SOCompletedContent";
import SalesOrderDetails from "./SalesOrderDetails";
import mainContext from "../context/MainContext/mainContext";

const CompletedTab = () => {
  const { id } = useContext(mainContext);

  return <>{id ? <SalesOrderDetails /> : <SOCompletedContent />}</>;
};

export default CompletedTab;
